import React from 'react';
import { Zap, Database, Filter } from 'react-feather';

const FeaturesSection: React.FC = () => {
    return (
    <section id="features-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="text-center mb-16">
                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-aos="fade-up">Pourquoi utiliser Le Panier Clair ?</h2>
                <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="100">
                    Notre extension vous aide à prendre des décisions éclairées en affichant les données nutritionnelles, le degré de transformation et l'impact environnemental directement lors de vos achats en ligne.
                </p>
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
                <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition" data-aos="fade-up">
                    <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                        <Zap className="w-8 h-8 text-green-600" />
                    </div>
                    <h3 className="text-xl font-bold text-center mb-4">Notes instantanées</h3>
                    <p className="text-gray-600 text-center">
                        Voyez les notes NutriScore, NOVA et EcoScore apparaître automatiquement pendant que vous naviguez sur les sites de courses en ligne compatibles.
                    </p>
                </div>
                
                <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition" data-aos="fade-up" data-aos-delay="100">
                    <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                        <Database className="w-8 h-8 text-green-600" />
                    </div>
                    <h3 className="text-xl font-bold text-center mb-4">Données OpenFoodFacts</h3>
                    <p className="text-gray-600 text-center">
                        Propulsé par la base de données complète OpenFoodFacts avec des milliers de produits analysés.
                    </p>
                    <div className="flex justify-center mt-4">
                        <img src="https://world.openfoodfacts.org/images/logos/off-logo-horizontal-light.svg" alt="OpenFoodFacts" className="h-8 object-contain" />
                    </div>
                </div>
                
                <div className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition" data-aos="fade-up" data-aos-delay="200">
                    <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                        <Filter className="w-8 h-8 text-green-600" />
                    </div>
                    <h3 className="text-xl font-bold text-center mb-4">Filtrage intelligent</h3>
                    <p className="text-gray-600 text-center">
                        Filtrez les résultats selon la note nutritionnelle ou environnementale pour trouver les produits qui correspondent à vos valeurs.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;